// app/lib/apiUtils.ts

import { authService } from './authService';

// Function to get headers, will be different for server and client
const getHeaders = () => {
  if (typeof window === 'undefined') {
    // Server-side
    const { headers } = require('next/headers');
    return headers();
  } else {
    // Client-side
    return new Headers();
  }
};

export async function authenticatedFetch(url: string, options: RequestInit = {}): Promise<Response> {
  console.log("authenticatedFetch: Starting fetch to URL:", url);
  const headersList = getHeaders();
  const serviceApiKey = process.env.SERVICE_API_KEY;
  const serviceId = process.env.SERVICE_ID;

  if (!serviceApiKey || !serviceId) {
    console.error("Service API Key or Service ID is not defined in environment variables");
    throw new Error("Service authentication failed due to missing credentials");
  }

  async function fetchWithToken(token: string): Promise<Response> {
    const defaultHeaders: Record<string, string> = {
      'Authorization': `Bearer ${token}`,
    };

    if (serviceApiKey) defaultHeaders['X-API-Key'] = serviceApiKey;
    if (serviceId) defaultHeaders['X-API-ID'] = serviceId;

    // Merge default headers with custom headers, giving priority to custom headers
    const mergedHeaders: Record<string, string> = {
      ...defaultHeaders,
      ...(options.headers as Record<string, string>),
    };

    // Remove any undefined values
    Object.keys(mergedHeaders).forEach(key =>
      mergedHeaders[key] === undefined && delete mergedHeaders[key]
    );

    // Create a new Headers object from the merged headers
    const headers = new Headers(mergedHeaders);

    if (options.body instanceof FormData) {
      headers.delete('Content-Type');
    }

    return fetch(url, { ...options, headers });
  }

  try {
    let accessToken = await authService.getAccessToken();
    let response = await fetchWithToken(accessToken);

    if (response.status === 401) {
      await authService.refreshTokens();
      accessToken = await authService.getAccessToken();
      response = await fetchWithToken(accessToken);
    }

    return response;
  } catch (error) {
    console.error("authenticatedFetch: Error occurred:", error);
    throw error;
  }
}

export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  return String(error);
}

export function logAndFormatError(error: unknown, context: string): { error: string } {
  const errorMessage = getErrorMessage(error);
  console.error(`Error in ${context}:`, error);
  return { error: errorMessage || 'Internal Server Error' };
}